var __defProp = Object.defineProperty;
var __export = (target, all) => {
  for (var name in all)
    __defProp(target, name, { get: all[name], enumerable: true });
};

// src/dateTime.ts
var dateTime_exports = {};
__export(dateTime_exports, {
  addDay: () => addDay,
  dayDifference: () => dayDifference,
  dayFormatter: () => dayFormatter,
  dayWrittenMonthFormatter: () => dayWrittenMonthFormatter,
  formatSecondsToTime: () => formatSecondsToTime,
  fullFormatter: () => fullFormatter,
  fullFormatterCurrentTimezone: () => fullFormatterCurrentTimezone,
  isDayInRange: () => isDayInRange,
  isSameDay: () => isSameDay,
  nowInUTC: () => nowInUTC,
  shortFormatter: () => shortFormatter,
  timeFormatter: () => timeFormatter,
  timeToSeconds: () => timeToSeconds,
  toDay: () => toDay,
  toDuration: () => toDuration,
  toRange: () => toRange,
  toTime: () => toTime
});
var dayFormatter = new Intl.DateTimeFormat(void 0, {
  month: "2-digit",
  day: "2-digit",
  // We show all datetimes in UTC
  timeZone: "UTC"
});
var dayWrittenMonthFormatter = new Intl.DateTimeFormat(void 0, {
  month: "long",
  day: "2-digit",
  // We show all datetimes in UTC
  timeZone: "UTC"
});
var timeFormatter = new Intl.DateTimeFormat(void 0, {
  hour: "2-digit",
  minute: "2-digit",
  // We show all datetimes in UTC
  timeZone: "UTC"
});
var shortFormatter = new Intl.DateTimeFormat(void 0, {
  month: "2-digit",
  day: "2-digit",
  hour: "2-digit",
  minute: "2-digit",
  // We show all datetimes in UTC
  timeZone: "UTC"
});
var fullFormatter = new Intl.DateTimeFormat(void 0, {
  weekday: "short",
  year: "2-digit",
  month: "2-digit",
  day: "2-digit",
  hour: "2-digit",
  minute: "2-digit",
  // We show all datetimes in UTC
  timeZone: "UTC"
});
var fullFormatterCurrentTimezone = new Intl.DateTimeFormat(void 0, {
  weekday: "short",
  year: "2-digit",
  month: "2-digit",
  day: "2-digit",
  hour: "2-digit",
  minute: "2-digit"
});
var dayInMilliseconds = 1e3 * 60 * 60 * 24;
function toRange({
  duration,
  isoDateTime,
  showAsOffset = false,
  hideStartDate = false,
  showShortDate = false,
  dayLabelTranslation = (count) => `${count} day`
}) {
  const startDate = new Date(isoDateTime);
  const dateFormatter = showShortDate ? shortFormatter : fullFormatter;
  const startFormatter = hideStartDate ? timeFormatter : dateFormatter;
  const startText = startFormatter.format(startDate);
  const endText = (() => {
    if (!duration) return "";
    const endTime = new Date(startDate.getTime() + duration);
    if (isSameDay(startDate, endTime)) {
      return ` - ${timeFormatter.format(endTime)}`;
    }
    if (showAsOffset) {
      const startDay = toDay(startDate);
      const endDay = toDay(endTime);
      const diffTime = Math.abs(endDay.getTime() - startDay.getTime());
      const diffDays = Math.ceil(diffTime / (1e3 * 60 * 60 * 24));
      return ` - ${timeFormatter.format(endTime)} (+${dayLabelTranslation(diffDays)})`;
    }
    return ` - ${dateFormatter.format(endTime)}`;
  })();
  return `${startText}${endText}`;
}
function toTime({ isoDateTime }) {
  const startDate = new Date(isoDateTime);
  const startTime = timeFormatter.format(startDate);
  return startTime;
}
function isSameDay(d1, d2) {
  return d1.getUTCFullYear() === d2.getUTCFullYear() && d1.getUTCMonth() === d2.getUTCMonth() && d1.getUTCDate() === d2.getUTCDate();
}
function isDayInRange(d1, d2) {
  return d1.getTime() >= d2.start.getTime() && d1.getTime() <= d2.end.getTime();
}
function addDay(date, days = 1) {
  const newDate = date.getTime() + days * 24 * 60 * 60 * 1e3;
  return new Date(newDate);
}
function toDay(date) {
  return new Date(
    Date.UTC(date.getUTCFullYear(), date.getUTCMonth(), date.getUTCDate())
  );
}
function dayDifference(date1, date2) {
  const day1 = toDay(date1).getTime();
  const day2 = toDay(date2).getTime();
  const diff = day2 - day1;
  return diff / dayInMilliseconds;
}
function toDuration(start, end) {
  return end.getTime() - start.getTime();
}
function formatSecondsToTime(seconds) {
  seconds = Math.max(0, Math.floor(seconds));
  const minutes = Math.floor(seconds / 60);
  const remainingSeconds = seconds % 60;
  const formattedMinutes = String(minutes).padStart(2, "0");
  const formattedSeconds = String(remainingSeconds).padStart(2, "0");
  return `${formattedMinutes}:${formattedSeconds}`;
}
function timeToSeconds(timeString) {
  const timeRegex = /^([0-5][0-9]):([0-5][0-9])$/;
  if (!timeRegex.test(timeString)) {
    throw new Error("Invalid time format. Please use MM:SS");
  }
  const [targetMinutes, targetSeconds] = timeString.split(":").map(Number);
  return targetMinutes * 60 + targetSeconds;
}
function nowInUTC() {
  const date = /* @__PURE__ */ new Date();
  const utcDate = new Date(date.toLocaleString("en-US", { timeZone: "UTC" }));
  const offset = date.getTime() - utcDate.getTime();
  return new Date((/* @__PURE__ */ new Date()).getTime() + offset);
}

// src/reccurences.ts
var reccurences_exports = {};
__export(reccurences_exports, {
  currentOccurence: () => currentOccurence,
  currentOrNextOccurence: () => currentOrNextOccurence,
  nextOccurence: () => nextOccurence,
  nextOccurences: () => nextOccurences,
  occurencesForDay: () => occurencesForDay,
  occurencesForMonth: () => occurencesForMonth,
  rangesBetweenOccurences: () => rangesBetweenOccurences,
  recurrenceToRRule: () => recurrenceToRRule,
  recurrencesToRRule: () => recurrencesToRRule,
  rruleToApiReadyString: () => rruleToApiReadyString
});
import { rrulestr } from "rrule";
function formatDate(date) {
  const isoString = date.toISOString();
  return isoString.replace(/[-:]/g, "").replace(/\.\d{3}/, "");
}
function recurrenceToRRule(recurrence) {
  const date = formatDate(new Date(recurrence.startDate));
  return {
    duration: recurrence.duration,
    rrule: rrulestr(`DTSTART:${date}
RRULE:${recurrence.rrule}`)
  };
}
function rruleToApiReadyString(rrule) {
  return rrule.toString().replace("RRULE:", "");
}
function recurrencesToRRule(recurrences) {
  return recurrences.map(recurrenceToRRule);
}
function occurencesForMonth(rrule, year, month) {
  const rules = Array.isArray(rrule) ? rrule : [rrule];
  const startDate = new Date(year, month, 1);
  const endDate = new Date(year, month + 1, 1);
  return rules.flatMap((rule) => {
    const offsetStart = new Date(startDate.getTime() - rule.duration);
    return rule.rrule.between(offsetStart, endDate).map((start) => ({
      start,
      end: new Date(start.getTime() + rule.duration),
      duration: rule.duration
    }));
  });
}
function occurencesForDay(rrule, day) {
  const rules = Array.isArray(rrule) ? rrule : [rrule];
  const start = new Date(day.getTime());
  start.setUTCHours(0, 0, 0);
  const end = new Date(day.getTime());
  end.setUTCHours(23, 59, 59);
  return rules.flatMap((rule) => {
    const offsetStart = new Date(start.getTime() - rule.duration);
    return rule.rrule.between(offsetStart, end).map((start2) => ({
      start: start2,
      end: new Date(start2.getTime() + rule.duration),
      duration: rule.duration
    }));
  });
}
function currentOccurence(rrule, date) {
  const rules = Array.isArray(rrule) ? rrule : [rrule];
  const startDate = date?.getTime() ?? Date.now();
  return rules.reduce(function(next, rule) {
    const startWithOffset = new Date(startDate - rule.duration);
    const currentOccurences = rule.rrule.between(
      startWithOffset,
      new Date(startDate)
    );
    const lastOccurence = currentOccurences[currentOccurences.length - 1];
    const currentRange = lastOccurence ? {
      start: lastOccurence,
      end: new Date(lastOccurence.getTime() + rule.duration),
      duration: rule.duration
    } : null;
    if (!next) return currentRange;
    if (lastOccurence && next.start > lastOccurence) return currentRange;
    return next;
  }, null);
}
function currentOrNextOccurence(rrule, date) {
  const rules = Array.isArray(rrule) ? rrule : [rrule];
  const startDate = date?.getTime() ?? Date.now();
  return rules.reduce(function(next, rule) {
    const startWithOffset = new Date(startDate - rule.duration);
    const nextOccurence2 = rule.rrule.after(startWithOffset);
    const nextRange = nextOccurence2 ? {
      start: nextOccurence2,
      end: new Date(nextOccurence2.getTime() + rule.duration),
      duration: rule.duration
    } : null;
    if (!next) return nextRange;
    if (nextOccurence2 && next.start > nextOccurence2) return nextRange;
    return next;
  }, null);
}
function nextOccurence(rrule, date) {
  const rules = Array.isArray(rrule) ? rrule : [rrule];
  const startDate = date ?? /* @__PURE__ */ new Date();
  return rules.reduce(function(next, rule) {
    const nextOccurence2 = rule.rrule.after(startDate);
    const nextRange = nextOccurence2 ? {
      start: nextOccurence2,
      end: new Date(nextOccurence2.getTime() + rule.duration),
      duration: rule.duration
    } : null;
    if (!next) return nextRange;
    if (nextOccurence2 && next.start > nextOccurence2) return nextRange;
    return next;
  }, null);
}
function nextOccurences(rrule, count, prevDate) {
  const occurences = [];
  let lastDate = prevDate;
  for (let index = 0; index < count; index++) {
    const occurence = nextOccurence(rrule, lastDate);
    if (!occurence) return occurences;
    occurences.push(occurence);
    lastDate = occurence.start;
  }
  return occurences;
}
function rangesBetweenOccurences(rrule, start, end) {
  const rules = Array.isArray(rrule) ? rrule : [rrule];
  return rules.flatMap(function(rule) {
    const startWithOffset = new Date(start.getTime() - rule.duration);
    const occurences = rule.rrule.between(startWithOffset, end, true);
    return occurences.map(function(occ) {
      const occEnd = new Date(occ.getTime() + rule.duration);
      const startDate = occ > start ? occ : start;
      const endDate = end > occEnd ? occEnd : end;
      return {
        start: startDate,
        duration: endDate.getTime() - startDate.getTime()
      };
    });
  }, null).toSorted((a, b) => a.start.getTime() - b.start.getTime());
}

// src/goodie.ts
var goodie_exports = {};
__export(goodie_exports, {
  formatAsPrice: () => formatAsPrice,
  isBookableFromGoodieFragment: () => isBookableFromGoodieFragment,
  setCurrentCurrency: () => setCurrentCurrency,
  toCurrentAvailabilityFromGoodieFragment: () => toCurrentAvailabilityFromGoodieFragment,
  toDuration: () => toDuration2,
  toGoodieType: () => toGoodieType,
  toInfo: () => toInfo,
  toInfoFromGoodieFragment: () => toInfoFromGoodieFragment,
  toNextOccurenceFromGoodieFragment: () => toNextOccurenceFromGoodieFragment,
  toNextOccurenceFromRecurrence: () => toNextOccurenceFromRecurrence,
  toPrice: () => toPrice,
  toPriceFromGoodieFragment: () => toPriceFromGoodieFragment
});
import { SharedAPI, getFragment, GraphQL } from "@guestgoodie/graphql";
var currentCurrency;
function setCurrentCurrency(currency) {
  currentCurrency = currency;
}
var toDuration2 = function(duration) {
  const minutes = Math.round(duration / 6e4);
  const hours = Math.floor(minutes / 60);
  const remainingMinutes = minutes % 60;
  if (hours === 0) {
    return `${remainingMinutes}m`;
  } else if (remainingMinutes === 0) {
    return `${hours}h`;
  } else {
    return `${hours}h ${remainingMinutes}m`;
  }
};
var toInfo = function({
  duration,
  location
}) {
  const final = [];
  if (location) final.push(location);
  if (duration) final.push(toDuration2(duration));
  return final.join(" | ");
};
var toPrice = function({
  price: priceCents,
  zeroText = void 0
}) {
  const price = (priceCents ?? 0) / 100;
  if (price === 0) return zeroText;
  return formatAsPrice(price);
};
function formatAsPrice(price) {
  if (!currentCurrency) {
    console.error(
      "No current currency was set, using the default which is EUR!"
    );
  }
  return new Intl.NumberFormat(void 0, {
    style: "currency",
    currency: currentCurrency ?? GraphQL.Currency.Eur,
    currencyDisplay: "narrowSymbol"
  }).format(price);
}
function toNextOccurenceFromRecurrence(recurrences, options = { includeCurrent: false, now: /* @__PURE__ */ new Date() }) {
  if (!recurrences) return null;
  const recs = recurrences.map(function(recFragment) {
    return getFragment(SharedAPI.recurrence.RECURRENCE_FRAGMENT, recFragment);
  });
  const rrules = recurrencesToRRule(recs);
  if (options.includeCurrent) {
    return currentOrNextOccurence(rrules, options.now);
  }
  return nextOccurence(rrules, options.now);
}
function toGoodieType(goodie) {
  switch (goodie.__typename) {
    case "Default":
      return goodie.default;
    case "Event":
      return goodie.event;
    default:
      return null;
  }
}
function toCurrentAvailabilityFromGoodieFragment(goodie) {
  const now = /* @__PURE__ */ new Date();
  switch (goodie.__typename) {
    case "Default":
      if (!goodie.default.openingHours) return null;
      return goodie.default.openingHours.flatMap(function(avFragment) {
        const availability = getFragment(
          SharedAPI.recurrence.RECURRENCE_FRAGMENT,
          avFragment
        );
        if (!availability) return null;
        const rrule = recurrenceToRRule(availability);
        return occurencesForDay(rrule, now);
      }).find((availability) => {
        if (!availability) return false;
        return availability.start < now && now < availability.end;
      });
    default:
      return null;
  }
}
function toNextOccurenceFromGoodieFragment(goodie, options) {
  switch (goodie.__typename) {
    case "Default":
      return toNextOccurenceFromRecurrence(goodie.default.openingHours, options);
    case "Event":
      return toNextOccurenceFromRecurrence(goodie.event.recurrences, options);
    default:
      return null;
  }
}
function toInfoFromGoodieFragment(goodie) {
  const type = toGoodieType(goodie);
  if (type) return toInfo(type);
  return null;
}
function toPriceFromGoodieFragment(goodie) {
  const type = toGoodieType(goodie);
  if (type) return toPrice(type);
  return null;
}
function isBookableFromGoodieFragment(goodie) {
  switch (goodie.__typename) {
    case "Event":
      return goodie.event.button === GraphQL.EventButtonType.Bookable;
    case "Default":
      return goodie.default.button === GraphQL.DefaultButtonType.Bookable;
    case "Message":
      return false;
  }
}

// src/index.ts
import {
  RRule as RRule2,
  Frequency,
  Weekday,
  rrulestr as rrulestr2
} from "rrule";
export {
  Frequency,
  RRule2 as RRule,
  Weekday,
  dateTime_exports as dateTime,
  goodie_exports as goodie,
  reccurences_exports as reccurences,
  rrulestr2 as rrulestr
};
//# sourceMappingURL=index.js.map